import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { logInWithExpiredPassword, setFormMessage, setSelectedForm } from '../actions';

import { setState } from '../../actions';
import { STATE__AUTHORIZED } from '../../constants';

import { setSelectedMenuItem } from '../../authorizedState/actions';
import { MENU_ITEM__FORMS__ASSIGNED } from '../../authorizedState/constants';

import { getValidationError, setValidationError } from '../../helpers/dataOperations/form/validationMessageHelper';
import { FORMS__SIGN_IN } from '../constants';

import initialEditorState from './initialEditorState';
import validateEditorState from './validateEditorState';

const SignInWithPasswordChange = ({ email }) => {
  const dispatch = useDispatch();

  const [validationMessage, setValidationMessage] = useState(undefined);
  const [editorState, setEditorState] = useState(initialEditorState());

  const singInSuccess = () => {
    dispatch(setState(STATE__AUTHORIZED));
    dispatch(setFormMessage(''));
    dispatch(setSelectedMenuItem(MENU_ITEM__FORMS__ASSIGNED));
  };

  const signInFailure = (apiInterceptedErrorDetails) => {
    const { value: message } = apiInterceptedErrorDetails || { value: 'Wystąpił nieoczekiwany błąd.' };

    setValidationMessage(setValidationError(message, 'form'));
  };

  const signInButtonClick = () => {
    const validateMessage = validateEditorState(editorState);

    if (validateMessage) {
      setValidationMessage(validateMessage);
    } else {
      dispatch(logInWithExpiredPassword(email, editorState.oldPassword, editorState.newPassword, singInSuccess, signInFailure));
    }
  };

  const onFormClick = (event) => {
    if (event.key === 'Enter') {
      signInButtonClick();
    }
  };

  const onReturnButtonClick = () => {
    dispatch(setSelectedForm(FORMS__SIGN_IN));
  };

  return (
    <div className="sign-in-with-password-change">
      <div className="title">
        Zmiana hasła
      </div>
      <div className="description">
        Utwórz nowe hasło i zaloguj się.
      </div>
      <div className="form" onKeyDown={onFormClick} role="button">
        <div className="form-group">
          <div className="error-message">
            {getValidationError(validationMessage, 'form')}
            {getValidationError(validationMessage, 'oldPassword')}
          </div>
          <label htmlFor="password">
            <div className="required-label-field">
              Stare hasło
            </div>
            <input
              className="form-control"
              id="oldPassword"
              type="password"
              value={editorState.oldPassword}
              onChange={(event) => setEditorState({ ...editorState, oldPassword: event.target.value })}
            />
          </label>
        </div>
        <div className="form-group">
          <div className="error-message">
            {getValidationError(validationMessage, 'newPassword')}
          </div>
          <label htmlFor="password">
            <div className="required-label-field">
              Nowe hasło
            </div>
            <input
              className="form-control"
              id="newPassword"
              type="password"
              value={editorState.newPassword}
              onChange={(event) => setEditorState({ ...editorState, newPassword: event.target.value })}
            />
          </label>
        </div>
      </div>
      <div className="actions">
        <div
          className="button sign-in-button"
          onClick={signInButtonClick}
          role="button"
          title="Zmnień hasło"
        >
          Zmnień hasło
        </div>
        <div
          className="button return-button float-right"
          onClick={onReturnButtonClick}
          role="button"
          title="Powrót"
        >
          Powrót
        </div>
      </div>
    </div>
  );
};

SignInWithPasswordChange.propTypes = {
  email: PropTypes.string.isRequired,
};

export default SignInWithPasswordChange;
